var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.751,
    height: 10.518,
    viewBox: "0 0 17.751 10.518",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#455079;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.007,18.908a1.684,1.684,0,0,1-2.374,0l-6.045-5.961L9.627,18.908a1.685,1.685,0,1,1-2.374-2.391l7.14-7.139a1.684,1.684,0,0,1,2.391,0l7.224,7.139a1.684,1.684,0,0,1,0,2.391Z",
    transform: "translate(-6.754 -8.879)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleUp);
export default __webpack_public_path__ + "static/media/angle-up.f70cc7367ba14e1b9aa3a68c38b80145.svg";
export { ForwardRef as ReactComponent };